import _ from 'underscore';
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { composePath } from '@culture/common-helpers/params';
import { EntitiesPropType, PaginationPropType } from 'propTypes/common';

import Catalog from 'components/catalogs/Catalog';
import Grid from 'components/Grid';
import PoemCard from 'components/cards/entities/PoemCard';
import Search from 'components/Search';
import FilterTags from 'components/filters/FilterTags';

import { renderPagination } from 'utils/helpers/pagination';
import styles from '../styles.module.scss';

const PoemsCatalog = ({ pagination, urlParams, poems, path, filters }) => {
	const [searchValue, setSearchValue] = useState('');
	const { push, asPath, query, pathname } = useRouter();

	useEffect(() => {
		setSearchValue(urlParams.query || '');
	}, [asPath]);

	const handleSearch = useCallback((event) => {
		setSearchValue(event.target.value);
	}, []);

	const handleKeyDown = useCallback(() => {
		if (searchValue) {
			push({
				pathname,
				query: {
					..._(query).omit('page'),
					query: searchValue
				}
			});
		}
	}, [pathname, query, searchValue]);

	const handleReset = useCallback(() => {
		setSearchValue('');

		push({
			pathname,
			query: _(query).omit('query')
		});
	}, [pathname, query]);

	const filterParams = _(urlParams).pick('author');
	const basePath = composePath(`/${path}`, filterParams);

	const prepareTags = filters.tags?.map((tag) => ({
		...tag,
		url: composePath(basePath, { tag: tag.name })
	}));

	const controls = (
		<>
			<div className={styles.controlsBlock}>
				<Search
					value={searchValue}
					onChange={handleSearch}
					onEnter={handleKeyDown}
					onReset={handleReset}
					theme="simple"
					placeholder="Введите автора или название стихотворения"
					hasClear={!!urlParams.query}
				/>
			</div>
			{!_.isEmpty(prepareTags) && (
				<div className={styles.controlsBlock}>
					<FilterTags
						selectedTag={urlParams.tag}
						tags={prepareTags}
						basePath={basePath}
						asPath={asPath}
					/>
				</div>
			)}
		</>
	);

	return (
		<Catalog
			controls={controls}
			footer={renderPagination(pagination)}
			emptyMessage="К сожалению, стихотворений по вашему запросу не найдено"
		>
			{!_.isEmpty(poems) && (
				<Grid
					colDefault={1}
					colMobileMedium={2}
					colTabletMedium={3}
					colTabletLarge={4}
				>
					{poems.map((poem) => (
						<PoemCard entity={poem} key={poem._id} />
					))}
				</Grid>
			)}
		</Catalog>
	);
};

PoemsCatalog.propTypes = {
	urlParams: PropTypes.object,
	poems: EntitiesPropType.isRequired,
	path: PropTypes.string.isRequired,
	pagination: PaginationPropType.isRequired,
	filters: PropTypes.shape({
		query: PropTypes.string,
		tags: PropTypes.array
	})
};

PoemsCatalog.defaultProps = {
	filters: {}
};

export default PoemsCatalog;
